import React, { useState } from 'react';

/**
 * Shows the top AI-suggested General Exception for a single deviation row.
 * Handles dismiss and swap between alternatives.
 *
 * Props:
 *   suggestions: [{ issueKey, title, score, browseUrl }]  — sorted best-first
 *   onChange: (selectedKey | null) => void                — called on every state change
 */
const GeneralExceptionSuggestion = ({ suggestions, onChange }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const [swapOpen, setSwapOpen] = useState(false);

  if (!suggestions || suggestions.length === 0) {
    return (
      <div style={{ fontSize: '12px', color: 'var(--ids-palette-neutral-60)', marginTop: '6px' }}>
        Ingen generell undantag hittad
      </div>
    );
  }

  if (dismissed) {
    return null;
  }

  const active = suggestions[activeIndex];
  const keyField = active.issueKey !== undefined ? 'issueKey' : 'key'; // handle both serializations

  const handleDismiss = () => {
    setDismissed(true);
    setSwapOpen(false);
    onChange(null);
  };

  const handleSwap = (originalIndex) => {
    setActiveIndex(originalIndex);
    setSwapOpen(false);
    onChange(suggestions[originalIndex][keyField]);
  };

  return (
    <div style={{ marginTop: '8px', fontSize: '13px' }}>
      <span style={{ color: 'var(--ids-palette-neutral-50)', marginRight: '6px' }}>Generell undantag:</span>
      <a
        href={active.browseUrl}
        target="_blank"
        rel="noreferrer"
        style={{ fontWeight: 500 }}
      >
        {active[keyField]} — {active.title}
      </a>
      <span
        onClick={handleDismiss}
        title="Ta bort"
        style={{ cursor: 'pointer', color: 'var(--ids-palette-neutral-60)', marginLeft: '8px' }}
      >
        ✕
      </span>
      {suggestions.length > 1 && (
        <>
          <span
            onClick={() => setSwapOpen(o => !o)}
            style={{ cursor: 'pointer', color: 'var(--ids-palette-primary-40)', marginLeft: '8px', fontSize: '12px' }}
          >
            Byt ▾
          </span>
          {swapOpen && (
            <div style={{
              position: 'absolute',
              background: 'white',
              border: '1px solid var(--ids-palette-neutral-90)',
              borderRadius: '4px',
              padding: '4px 0',
              zIndex: 10,
              minWidth: '300px',
            }}>
              {suggestions.map((s, i) => i === activeIndex ? null : (
                <div
                  key={s[keyField]}
                  onClick={() => handleSwap(i)}
                  style={{ padding: '6px 12px', cursor: 'pointer' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--ids-palette-information-95)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'white'}
                >
                  <a href={s.browseUrl} target="_blank" rel="noreferrer"
                     onClick={e => e.stopPropagation()}
                     style={{ fontWeight: 500 }}>
                    {s[keyField]}
                  </a>
                  {' — '}{s.title}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default GeneralExceptionSuggestion;
